import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Error as ErrorIcon, Refresh } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('[ErrorBoundary] Caught error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '400px',
                        p: 4,
                    }}
                >
                    <Paper
                        elevation={0}
                        sx={{
                            p: 4,
                            maxWidth: 500,
                            textAlign: 'center',
                            backgroundColor: 'var(--card-bg)',
                            border: '1px solid var(--border)',
                        }}
                    >
                        <ErrorIcon sx={{ fontSize: 64, color: 'var(--error)', mb: 2 }} />
                        <Typography variant="h5" gutterBottom sx={{ color: 'var(--text-1)' }}>
                            Something went wrong
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'var(--text-2)', mb: 3 }}>
                            {this.state.error?.message || 'An unexpected error occurred'}
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<Refresh />}
                            onClick={() => {
                                this.setState({ hasError: false, error: null });
                                if (this.props.onReset) this.props.onReset();
                            }}
                            sx={{
                                backgroundColor: 'var(--brand-2)',
                                '&:hover': { backgroundColor: 'var(--brand-1)' },
                            }}
                        >
                            Try Again
                        </Button>
                    </Paper>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
